<template>
  <v-expansion-panel @change="handlePanelChanged" @click.native.stop>
    <v-expansion-panel-header>Campaign URLs</v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row class="mt-n4" align="center">
        <v-col cols="2">
          <v-btn x-small text class="py-4" @click="copyUrl(shortUrlId)">
            <v-icon style="cursor: pointer">mdi-content-copy</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="10">
          <div class="body-1 text-left">{{ shortUrl }}</div>
          <div class="caption text-left text--secondary">{{ computedUrl }}</div>
        </v-col>
      </v-row>
      <v-row align="center">
        <ShortUrlQrCode :url="shortUrl" />
      </v-row>

      <v-row v-if="addressesLoading" class="mt-4">
        <v-col cols="12" class="text-h4 pt-0">
          <app-spinner />
        </v-col>
      </v-row>

      <v-row v-else-if="addresses.length > 0" class="mb-4">
        <v-col>
          <v-divider />
        </v-col>
      </v-row>

      <SwayOfferAddress
        v-for="address in addresses"
        :key="address.id"
        :address="address"
        :sway-offer-id="swayOfferId"
        @sway-offer-address-url-generated="handleAddressUrlGenerated"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Vue from 'vue'

import { ApiService } from '@/services/index'
import { copyToClipboard } from '@/mixins/copyToClipboard'
import ShortUrlQrCode from '@/components/Offers/OfferPanels/ShortUrlQrCode'
import SwayOfferAddress from '@/components/SwayOffers/SwayOfferAddress'

export default Vue.extend({
  name: 'SwayOfferUrlPanel',

  components: {
    SwayOfferAddress,
    ShortUrlQrCode,
  },

  mixins: [copyToClipboard],

  props: {
    swayOfferId: {
      type: String,
      required: true,
    },
    shortUrlId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    addresses: [],
    addressesLoading: false,
    addShortUrlLoading: false,
  }),

  computed: {
    baseShortUrl() {
      return process.env.VUE_APP_SHORT_URL
    },
    shortUrl() {
      return `${this.baseShortUrl}${this.shortUrlId}`
    },
    computedUrl() {
      return `${process.env.VUE_APP_DIVOC_API_URL}/swayOffer/claim/${this.swayOfferId}`
    },
  },

  methods: {
    copyUrl(urlId) {
      this.copyToClipboard(`${this.baseShortUrl}${urlId}`)
      this.$toast.success('Copied to clipboard!')
    },
    handlePanelChanged() {
      this.addressesLoading = true

      ApiService.get(`swayOffer/${this.swayOfferId}/addresses`).then((response) => {
        this.addresses = response.data
        this.addressesLoading = false
      })
    },
    handleAddressUrlGenerated(event) {
      const { addressId, shortUrlId } = event
      const addressIndex = this.addresses.findIndex((address) => address.id === addressId)

      this.addresses[addressIndex].short_url_id = shortUrlId
    },
  },
})
</script>
